import * as React from 'react';
import { getAttachementUploadUrl } from 'containers/OutWorkbench/utils';
import SmMaking, {
  MakingProps,
} from 'containers/SmWorkbench/ProjectDetail/Show/Detail/Bottom/Making';
import { QuotationsType } from 'containers/OutWorkbench/utils';
import PropTypes from 'prop-types';
import { XiaoHao } from './XiaoHao';
import { hasGrayConfigWithoutGroup } from 'utils/gray';
import _ from 'lodash';
import { getDetailFileList } from './XiaoHao/utils';
import { Alert } from '@bedrock/components';

const handleFormItems = (
  formItems: Array<Record<string, any>>,
  detail: Record<string, any>,
) => {
  formItems.forEach((v: any) => {
    if (v.key === 'settle_report_attachs_blob_ids') {
      const tmp = getDetailFileList(detail);
      v.childProps.defaultFileList = tmp;
    }
  });
  return formItems;
};

export default class Making extends React.Component<MakingProps> {
  public static contextTypes = {
    menuKey: PropTypes.string,
    detail: PropTypes.any,

    loadDetail: PropTypes.func,
    projectMove: PropTypes.func,
  };

  handleSubmitBody = (submitBody: any) => {
    if (hasGrayConfigWithoutGroup(['external.demand_flow.making'])) {
      const { id, making } = submitBody;
      const {
        is_pass = false,
        settle_report_attachs_blob_ids = [],
        demand_advertising_attributes = {},
          ...other
      } = making || {};

      return {
        id,
        state: 'making',
        pass: is_pass,
        form: {
          id,
          final_settle_price: _.get(
            demand_advertising_attributes,
            'final_settle_price'
          ),
          final_settle_currency: _.get(
            demand_advertising_attributes,
            'final_settle_currency'
          ),
          settle_report_attachs_blob_keys: (
            settle_report_attachs_blob_ids || []
          ).map((i: any) => i.blob_key),
            ...other,
        },
      };
    }

    return submitBody;
  }

  render() {
    const { detail, menuKey, loadDetail, projectMove } = this.context;
    const { demand_advertising = {} } = detail;
    const isAdsXiaohao =
      demand_advertising.ad_settle_way === QuotationsType.XIAOHAO;

    return (
      <>
        {detail?.return_flag && <Alert
          message='提交结案退回'
          description={`退回原因：${detail?.return_reason || '--'}`}
          type='warning'
          showIcon
          style={{ margin: `0 24px 20px` }}
        />}
        {isAdsXiaohao ? (
          <XiaoHao
            {...this.props}
            detail={detail}
            projectMove={projectMove}
            menuKey={menuKey}
            loadDetail={loadDetail}
            handleSubmitBody={this.handleSubmitBody}
          />
        ) : (
          <SmMaking
            {...this.props}
            templateDownloadUrl="outsource/v2/demands/download_case_template"
            handleSubmitBody={this.handleSubmitBody}
            attachementUploadUrl={getAttachementUploadUrl()}
            handleFormItems={handleFormItems}
          />
        )}
      </>
    );
  }
}
